import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=1fab9ad0&scoped=true"
import script from "./Overall.vue?vue&type=script&lang=js"
export * from "./Overall.vue?vue&type=script&lang=js"
import style0 from "./Overall.vue?vue&type=style&index=0&id=1fab9ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab9ad0",
  null
  
)

export default component.exports